import React from 'react';
import styles from './AdminPage.module.css';

const cx = (...parts) => parts.filter(Boolean).join(' ');

export const AdminLayout = ({ children, style, className }) => (
    <div className={cx(styles.adminLayout, className)} style={style}>{children}</div>
);

export const AdminSidebar = ({ children, open = false, style, className }) => (
    <div className={cx(styles.sidebarLayer, open && styles.sidebarOpen, className)} style={style}>
        {children}
    </div>
);

export const AdminHeader = ({ children, style, className }) => (
    <header className={cx(styles.adminHeader, className)} style={style}>{children}</header>
);

export const PageContainer = ({ children, style, className }) => (
    <main className={cx(styles.pageContainer, className)} style={style}>{children}</main>
);

export const ResponsiveCard = ({ children, style, className }) => (
    <section className={cx(styles.responsiveCard, className)} style={style}>{children}</section>
);

export const ResponsiveTable = ({ children, style, className }) => (
    <div className={cx(styles.tableScroll, className)} style={style}>{children}</div>
);

export const ModalShell = ({ children, onClick, style, className }) => (
    <div className={cx(styles.modalShell, className)} style={style} onClick={onClick}>{children}</div>
);

export default AdminLayout;
